import { useEffect } from 'react';

import type { UseAiAgentsEffectsParams } from '@pages/AiAgents/types';

export const useAiAgentsEffects = ({
  scrollToBottom,
  markMessagesAsRead,
  connectWs,
  disconnectWs,
}: UseAiAgentsEffectsParams): void => {
  useEffect(() => {
    scrollToBottom();
  }, [scrollToBottom]);

  useEffect(() => {
    void markMessagesAsRead();
  }, [markMessagesAsRead]);

  useEffect(() => {
    void connectWs();

    return () => {
      void disconnectWs();
    };
  }, [connectWs, disconnectWs]);
};
